import * as React from 'react';
import { PieChart, Pie, Cell, Legend, ResponsiveContainer } from 'recharts';

const DonutChart = ({ labelsToRender, seriesToRender }) => {
  const data = labelsToRender.map((label, i) => ({ name: label, value: seriesToRender[i] }));
  const COLORS = ['#000080', '#808080'];

  return (
    <div className="chart-wrap" style={{ width: 380, height: 380 }}>
      <ResponsiveContainer>
        <PieChart>
          <Pie
            data={data}
            dataKey="value"
            nameKey="name"
            innerRadius={80}
            outerRadius={120}
            label={false}
          >
            {data.map((entry, index) => (
              <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} />
            ))}
          </Pie>
          <Legend layout="vertical" verticalAlign="middle" align="left" />
        </PieChart>
      </ResponsiveContainer>
    </div>
  );
};

export default DonutChart;
